package com.techspiration.webuserapp.home

/**
 * Ana sayfada gösterilen **temsilî** ilan kartının verisi.
 *
 * @param institution kurum adı.
 * @param title unvan / pozisyon.
 * @param city il.
 * @param deadline son başvuru tarihi (gün.ay.yıl — insan okuru için, ISO değil).
 * @param educationLevel aranan eğitim düzeyi.
 */
data class SampleListing(
    val institution: String,
    val title: String,
    val city: String,
    val deadline: String,
    val educationLevel: String,
)

/**
 * Ana sayfadaki üç örnek ilan — **STATİK**. Bu veri veritabanından/backend'den ÇEKİLMEZ, kod
 * içinde sabittir ve gerçek bir ilana karşılık GELMEZ; amacı yalnızca uygulamadaki ilan kartının
 * nasıl göründüğünü tanıtım sayfasında göstermektir.
 *
 * Yanıltmayı önlemek için iki önlem BİRLİKTE uygulanır (bkz. [SampleListingsSection]):
 * - Her kartta görünür **"Örnek"** rozeti,
 * - Kartlar **tıklanamaz** (link/başvuru butonu yok) — kullanıcı gerçek bir ilana gittiğini sanamaz.
 *
 * Tek başına "tıklanamaz" yapmak yetmezdi (kullanıcı gerçek ama bozuk bir kart sanabilir); tek
 * başına rozet de yetmezdi (rozet gözden kaçıp tıklanır). Gerçek ilanlar yalnızca mobil
 * uygulamada gösterilir — bu yüzden burada gerçek veriye bağlanmak zaten istenmiyor.
 *
 * Sayaçların aksine (onlar canlı; bkz. [ListingStatsSection]) burada güncellik iddiası yoktur;
 * tarihler bilinçli olarak takvimden bağımsız, temsilî değerlerdir.
 */
val SAMPLE_LISTINGS: List<SampleListing> = listOf(
    SampleListing(
        institution = "Sağlık Bakanlığı",
        title = "Sözleşmeli Hemşire",
        city = "Ankara",
        deadline = "12.09.2026",
        educationLevel = "Lisans",
    ),
    SampleListing(
        institution = "İzmir Büyükşehir Belediyesi",
        title = "İtfaiye Eri",
        city = "İzmir",
        deadline = "28.08.2026",
        educationLevel = "Ön lisans",
    ),
    SampleListing(
        institution = "Karayolları Genel Müdürlüğü",
        title = "Sürekli İşçi (İŞKUR Kurası)",
        city = "Konya",
        deadline = "05.09.2026",
        educationLevel = "Lise",
    ),
)
